<template>
  <input-cleave
    type="text"
    class="input input--border input--radius"
    :id="id"
    :name="name"
    :placeholder="placeholder"
    :disabled="disabled"
    :options="options"
    :format="formatNationalId"
    :unformat="unformatNationalId"
    v-bind="$attrs"
    v-model="nationalId"
    @blur="handleInputBlurred()"
  />

  <p
    class="input--errors input--error"
    v-if="v?.$error"
  >
    <template v-if="v.required?.$invalid">
      {{ t('errors.input_text_required') }}
    </template>

    <template v-else-if="v.minLength?.$invalid">
      {{ t('errors.input_national_id_invalid') }}
    </template>

    <template v-else-if="v.external?.$invalid && v.external.$message">
      {{ v.external.$message }}
    </template>
  </p>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { formatGeneral, unformatGeneral } from 'cleave-zen'

import InputCleave from '&/atoms/InputCleave'

const model = defineModel({ type: String })

const { delimiters, blocks, v } = defineProps({
  id: String,
  name: { type: String, default: 'input-national-id' },
  placeholder: { type: String, default: '...' },
  disabled: { type: Boolean, default: false },
  delimiters: { type: Array, default: () => ['.', '.', '-', '.'] },
  blocks: { type: Array, default: () => [2, 2, 2, 3, 2] },
  v: Object
})

const { t } = useI18n()

const limit = computed(() => blocks.reduce((sum, number) => sum + number, 0))
const options = computed(() => ({ delimiters, blocks, numericOnly: true }))

const nationalId = computed({
  get: () => model.value,
  set: value => model.value = value.slice(0, limit.value)
})

const formatNationalId = value => value ? formatGeneral(value, options.value) : ''
const unformatNationalId = value => unformatGeneral(value, options.value)

const handleInputBlurred = () => v?.$touch()
</script>
